module.exports = __webpack_public_path__ + "static/img/19.0beded8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/19.png
// module id = eD1X
// module chunks = 1